import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { VouchersTable } from 'bundles/backoffice/vouchers/index/table';

export function Voucher({ deal }) {
  return <React.Fragment>
    <h2>Voucher</h2>
    <hr className="mt-0" />
    <table className="table bordered bo-search-results">
      <VouchersTable minimal vouchers={[{ ...deal.voucher, listing: deal.listing }]} />
    </table>
  </React.Fragment>;
}

Voucher.propTypes = {
  deal: PropTypes.shape({
    listing: PropTypes.object,
    voucher: PropTypes.object.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(Voucher);
